module.exports = __webpack_public_path__ + "static/media/Popice.62f0e118.md";